module.exports = __webpack_public_path__ + "img/topic-wheel.34b906ce.png";